import React from 'react'
import PlayerWrapper from 'components/set/InteractionPlayer/PlayerWrapper/PlayerWrapper'
import PosterImage from 'components/common/PosterImage/PosterImage'

interface PlayerWrapperWithPosterProps {
    children?: React.ReactNode
    posterImg: string
    stateId: string
}

const PlayerWrapperWithPoster: React.FC<PlayerWrapperWithPosterProps> = ({ children, posterImg, stateId }) => {
    return (
        <PlayerWrapper stateId={stateId}>
            <PosterImage src={posterImg} />
            {children}
        </PlayerWrapper>
    )
}

export default React.memo(PlayerWrapperWithPoster)
